import { ia, mString } from 'lib/helpers/utility';

const AMOUNT_KEYS = ['amount', 'charge', 'cents']; // Fields containing these substrings will be formatted as amounts
const AMOUNT_FIELDS = ['pt_balance', 'tax']; // Exact field names to be formatted as amounts
const NON_BASIC_PERCENT_FIELDS = ['percentage', 'local_tax_rate', 'state_tax_rate']; // Basis points fields (stored as 0-10000, displayed as 0-100%)
const BASIC_PERCENT_FIELDS = []; // Simple percentage fields (stored as 0-100, displayed with % suffix)

const checkIsAmount = (key, value) =>
  !key?.includes('_id') &&
  !isNaN(value) &&
  (AMOUNT_FIELDS.includes(key) || AMOUNT_KEYS.some((field) => key.includes(field)));

const checkIsPercent = (key, value, fields = []) =>
  !key?.includes('_id') && !isNaN(value) && fields.includes(key);

const handleBoolean = (val) => (val ? 'Yes' : 'No');

const handleObject = (obj, parentKey) =>
  Object.keys(obj)
    .map((key) => {
      const formattedKey = formatLabel(key);
      const renderedValue = renderValue(key || parentKey, obj[key]);

      return formattedKey ? `${formattedKey} - ${renderedValue}` : renderedValue;
    })
    .join('<br/>');

export const renderValue = (key, value) => {
  const isAmount = checkIsAmount(key, value);
  const isNonBasicPercent = checkIsPercent(key, value, NON_BASIC_PERCENT_FIELDS);
  const isBasicPercent = checkIsPercent(key, value, BASIC_PERCENT_FIELDS);

  if (ia(value)) {
    return value
      .map((item) => {
        if (typeof item === 'object' && item !== null) {
          return handleObject(item, key);
        }
        if (typeof item === 'boolean') {
          return handleBoolean(item);
        }

        return item || 'blank';
      })
      .join('\n');
  }

  if (typeof value === 'object' && value !== null) {
    return handleObject(value);
  }

  if (typeof value === 'boolean') {
    return handleBoolean(value);
  }

  if (isNonBasicPercent) {
    return `${Number(value) / 100}%`;
  }

  if (isBasicPercent) {
    return `${value}%`;
  }

  if (isAmount) {
    return mString(value);
  }

  return value || 'blank';
};

export const formatLabel = (key) => {
  if (typeof key === 'object' && key !== null) {
    return Object.keys(key).reduce((acc, nestedKey) => {
      acc[formatLabel(nestedKey)] = formatLabel(key[nestedKey]);
      return acc;
    }, {});
  }
  return key
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase());
};

export const isEmptyOrBlank = (data) => {
  if (data === null) return true;

  // If it's an array, check each element
  if (ia(data)) {
    return data.every((item) => isEmptyOrBlank(item));
  }

  // If it's an object, check all its values
  if (typeof data === 'object') {
    const values = Object.values(data);
    return values.every((value) => isEmptyOrBlank(value));
  }

  // Check primitive value
  const strValue = String(data).trim().toLowerCase();
  return strValue === '' || strValue === 'blank' || strValue === 'null' || strValue === 'undefined';
};
